import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseTwoTone } from 'common/icons';
import styles from './search.module.css';

type SearchProps = {
  onChange: (searchTerm: string) => void;
  onEnter?: () => void;
  placeholder?: string;
};

type SearchState = {
  isExpanded: boolean;
  searchTerm: string;
};

const Search: React.FC<SearchProps> = ({ onChange, onEnter, placeholder }) => {
  const [t] = useTranslation();
  const [state, setState] = useState<SearchState>({ isExpanded: false, searchTerm: '' });
  const { searchTerm, isExpanded } = state;

  const expandSearch = () => {
    setState({ isExpanded: true, searchTerm: '' });
    onChange('');
  };

  const clearSearchTerm = () => {
    setState({ isExpanded: false, searchTerm: '' });
    onChange('');
  };

  const updateSearchTerm = (event: React.ChangeEvent<HTMLInputElement>) => {
    const term = event.target.value;
    setState({ ...state, searchTerm: term });
    onChange(term);
  };

  const renderCollapsed = (
    <button className="btn btn-light" onClick={expandSearch} style={{ height: '38px' }}>
      {placeholder ? t(placeholder) : t('common.search')}
    </button>
  );
  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      // Aquí puedes ejecutar la lógica que desees al presionar Enter
      if (onEnter) {
        onEnter();
        setState({ isExpanded: true, searchTerm: '' });
      }
    }
  };

  const renderExpanded = (
    <Fragment>
      <button className={styles.cancel} onClick={clearSearchTerm}>
        <CloseTwoTone />
      </button>
      <input
        type="text"
        autoFocus
        className="form-control"
        value={searchTerm}
        onChange={updateSearchTerm}
        onKeyDown={handleKeyPress}
        placeholder={placeholder ? t(placeholder) : t('common.search')}
        style={{ lineHeight: 1.5, height: '38px' }}
      />
    </Fragment>
  );

  return (
    <div className={`${styles.root} ${isExpanded ? styles.expanded : ''}`}>
      {isExpanded ? renderExpanded : renderCollapsed}
    </div>
  );
};

export default Search;
